<template>
  <div class="can-pedalsure hp-block-container">
    <h2 class="hp-block-title">What does cargo bike insurance cover?</h2>
    <div class="hp-prose">
      <p>
        Whether you’re taking the kids to school, nipping to the shops to stock
        up or taking the dog for a quick spin, cargo bikes are built with you
        and your everyday needs in mind.
      </p>
      <p>
        We know that cargo bikes, particularly e-cargo bikes, don’t come cheap
        and that’s where we come in: we insure all types of cargo bike to keep
        you and your cargo bike protected.
      </p>
      <p>
        As standard, our insurance covers your cargo bike against theft and
        accidental damage and you can add only as much as you need on top of
        that: accessories and personal items cover, personal injury cover and
        third party liability protection to cover you if someone makes a claim
        against you after an incident involving your cargo bike out on the road.
      </p>
    </div>
    <div class="element-container hp-cards">
      <div>
        <b>Theft</b>: You’ll be covered if your cargo bike gets stolen, whether
        at home or out and about.
      </div>
      <div>
        <b>Damage</b>: We’ll pay for the repair costs if you’ve accidentally
        damaged your cargo bike or accessories or they’ve been vandalised.
      </div>
      <div>
        <b>Personal injury</b>: Injured yourself after an incident out on the
        road? We can provide compensation to help ease the pain.
      </div>
      <div>
        <b>Public liability</b>: If someone else gets injured or their property
        damaged and they think you’re to blame, we’ll take care of it if they
        make a claim against you.
      </div>
    </div>
    <div class="hp-prose">
      <p>
        Use your cargo bike for commercial purposes? Our policies are designed
        for personal use but you can
        <nuxt-link to="/contact-us"> get in touch with us </nuxt-link> directly
        to discuss a bespoke quote.
      </p>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.can-pedalsure {
  border-top: 1px solid $ps-border;
  border-bottom: 1px solid $ps-border;
}

.title {
  text-align: center;
  font-family: $family-regular;
  margin: 20px 0 0 0;
  font-size: 1.6rem;
  @include tablet {
    margin: 50px 0;
    font-size: 2.5rem;
  }
}
.subtitle {
  color: $ps-gray;
  line-height: 2rem;
}
</style>
